export default __webpack_public_path__ + "static/media/illustrasjoner16.83fd232c.svg";